import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmRemarksDialogData {
  title: string;
  message: string;
  remarksLabel?: string;
  remarksRequired?: boolean;
  confirmText?: string;
  confirmColor?: 'primary' | 'warn';
}

@Component({
  selector: 'app-confirm-remarks-dialog',
  templateUrl: './confirm-remarks-dialog.component.html',
  styleUrls: ['./confirm-remarks-dialog.component.css'],
  standalone: false,
})
export class ConfirmRemarksDialogComponent {
  remarks = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmRemarksDialogComponent, string | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmRemarksDialogData,
  ) {}

  confirm(): void {
    if (this.data.remarksRequired && !this.remarks.trim()) return;
    this.dialogRef.close(this.remarks.trim() || undefined);
  }
}
